"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenewPolicyAsIs = void 0;
var next_notifications_1 = require("@newfront-insurance/next-notifications");
var use_mutation_1 = __importDefault(require("use-mutation"));
var policy_api_1 = require("../api/policy-api");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/explicit-module-boundary-types
function useRenewPolicyAsIs() {
    var policyApi = policy_api_1.usePolicyApi();
    var notifications = next_notifications_1.useNotifications();
    return use_mutation_1.default(function (_a) {
        var body = _a.body;
        return policyApi.renewAsIs(body);
    }, {
        onSuccess: function (_a) {
            var data = _a.data;
            if (!data)
                return;
            notifications.add({ title: 'Policy renewed successfully...', type: 'success' });
        },
        throwOnFailure: true,
    });
}
exports.useRenewPolicyAsIs = useRenewPolicyAsIs;
